/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ecg': {
    width: 20,
    height: 16,
    viewBox: '0 0 20 16',
    data: '<path pid="0" d="M10.056 16L5.843 4.807l-1.932 5.264H0v-1.7h2.756L5.824.015l4.12 10.943 2.4-7.36L14.68 8.37H20v1.7h-6.349l-1-2.037z" _fill="#474950" fill-rule="evenodd"/>'
  }
})
